import { Injectable } from '@angular/core';
import { Alert } from '../models/alert';
import { AlertSeverity } from '../enums/alert-severity';
import { ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class AlertToPrimengMessageConverter {
  public convert(alert: Alert): ToastMessageOptions {
    return {
      detail: alert.content,
      summary: alert.title,
      closable: alert.closeable,
      severity: this.convertToPrimengSeverity(alert.severity),
      icon: undefined,
    };
  }

  private convertToPrimengSeverity(severity: AlertSeverity): string {
    switch (severity) {
      case AlertSeverity.Failure:
        return 'error';

      case AlertSeverity.Success:
        return 'success';

      case AlertSeverity.Warning:
        return 'warn';

      case AlertSeverity.Info:
        return 'info';
    }
  }
}
